import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import * as classes from "./SportsCarousel.module.scss";
import Link from "../../services/utility";
import { useDispatch, useSelector } from "react-redux";
import ProductModal from "../MessageComponents/ProductModal";
import { useState } from "react";
import { getSlugBy, SearchService } from "../../services/services";
import { navigate } from "gatsby";
import { Sessionstore } from "../../Store/StoreData";
import { FailureModalShow } from "../../Store/Action/Action";
import TravelAd from "../../assets/images/TravelAd.png";
import Carousel from "react-multi-carousel";
import { dynamicHomePage } from "../../services/SEOServices";
const options = {
  margin: 25,
  responsiveClass: true,
  nav: true,
  dots: true,
  loop: false,
  autoplay: false,
  navText: [
    "<i class='material-icons-outlined owl_arrows' tabIndex='-1'>arrow_back</i>",
    "<i class='material-icons-outlined owl_arrows' tabIndex='-1'>arrow_forward</i>",
  ],
  smartSpeed: 1000,
  responsive: {
    0: {
      items: 2,
    },
    400: {
      items: 2,
    },
    600: {
      items: 2,
    },
    700: {
      items: 3,
    },
    1100: {
      items: 4,
    },
  },
};

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 564, min: 0 },
    items: 1,
  },
};

function SportsCarousel({ dynamicHeading }) {
  let dispatch = useDispatch();
  const cmsData = useSelector((state) => state.HomeCMSData);
  const [isProductModal, setIsProductModal] = useState(false);
  console.log(dynamicHeading, "sportcuuuuu");
  return (
    <>
      <div className={classes.sportsSec}>
        <div className="mainsec">
          {dynamicHeading &&
            dynamicHeading?.today_blocks[0]?.__component ===
              "home-new.showcase" && (
              <h4 className="h4_para">
                {dynamicHeading?.today_blocks[0]?.title}
                <Link
                  className={`onlyMob ${classes.seeall}`}
                  aria-label="See All Sports Services"
                >
                  See all{" "}
                  <span
                    aria-hidden="true"
                    className="material-symbols-outlined"
                  >
                    arrow_forward_ios
                  </span>
                </Link>
              </h4>
            )}
          {/* <h4 className="h4_para">
            IN SPORTS TODAY
            <Link
              className={`onlyMob ${classes.seeall}`}
              aria-label="See All Sports Services"
            >
              See all{' '}
              <span aria-hidden="true" className="material-symbols-outlined">
                arrow_forward_ios
              </span>
            </Link>
          </h4> */}

          <div
            className={classes.imagesSec}
            aria-label="List of Sports news"
            // role="menubar"
          >
            {dynamicHeading && (
              <Carousel
                autoPlay={false}
                autoPlaySpeed={1000}
                arrows={false}
                infinite={false}
                responsive={responsive}
                className="container"
              >
                {/* {cmsData?.sports_today?.map((item, index) => ( */}
                {dynamicHeading.today_blocks[0].__component ===
                  "home-new.showcase" &&
                  dynamicHeading.today_blocks[0].details.map((item, index) => {
                    console.log(item.details, "sporttodayayaa");
                    return (
                      <div
                        className={classes.items}
                        role="menuitem"
                        tabIndex="0"
                        key={index}
                        aria-label={item.title + "link"}
                        // aria-title={item.title}
                        onKeyPress={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            console.log("test");
                            var data = {
                              listing_id: parseInt(item.link_id),
                            };
                            getSlugBy(data)
                              .then((response) => {
                                if (response.data.success) {
                                  navigate(`${response.data.data}`);
                                } else {
                                  dispatch(
                                    FailureModalShow({
                                      show: true,
                                      msg: response.data.message,
                                    })
                                  );
                                }
                              })
                              .catch((error) => {
                                dispatch(
                                  FailureModalShow({
                                    show: true,
                                    msg: error.message,
                                  })
                                );
                              });
                          }
                        }}
                        onClick={() => {
                          var data = {
                            listing_id: parseInt(item.link_id),
                          };
                          getSlugBy(data)
                            .then((response) => {
                              if (response.data.success) {
                                navigate(`${response.data.data}`);
                              } else {
                                dispatch(
                                  FailureModalShow({
                                    show: true,
                                    msg: response.data.message,
                                  })
                                );
                              }
                            })
                            .catch((error) => {
                              dispatch(
                                FailureModalShow({
                                  show: true,
                                  msg: error.message,
                                })
                              );
                            });
                        }}
                      >
                        <img
                          src={item?.bg_image?.data?.url}
                          // alt={item?.background.data.alternativeText}
                          //role="img"
                          className="w-100 d-block"
                        ></img>
                        <p aria-hidden="true" className="preserve-whitespace">
                          {item.title}
                        </p>
                      </div>
                    );
                  })}
              </Carousel>
            )}
            {/* <OwlCarousel className="owl-theme" {...options}>
              {cmsData?.sports_today?.map((item, index) => (
                <div
                  className={classes.items}
                  role="link"
                  tabIndex="0"
                  key={index}
                  aria-label={item.title}
                  // aria-title={item.title}
                  onClick={() => {
                    var data = {
                      listing_id: parseInt(item.link_id),
                    }
                    getSlugBy(data)
                      .then(response => {
                        if (response.data.success) {
                          navigate(`${response.data.data}`)
                        } else {
                          dispatch(
                            FailureModalShow({
                              show: true,
                              msg: response.data.message,
                            })
                          )
                        }
                      })
                      .catch(error => {
                        dispatch(
                          FailureModalShow({
                            show: true,
                            msg: error.message,
                          })
                        )
                      })
                  }}
                >
                  <img
                    src={item?.background.data.url}
                    alt={item?.background.data.alternativeText}
                    role="img"
                  ></img>
                  <p className="preserve-whitespace">{item.title}</p>
                </div>
              ))}
            </OwlCarousel> */}
          </div>
          <Link
            className={`onlyDes ${classes.seeall} ${classes.mt25}`}
            to="/sports"
            onClick={() => {
              let finaldata = {
                category: 5,
                classification: null,
                search_term: null,
                deals_check: 0,
              };
              Sessionstore("SearchData", finaldata);
              Sessionstore(
                "RelatedServiceData",
                JSON.stringify({ data: cmsData?.sports_today, type: "cms" })
              );
            }}
            aria-label="show all rows"
            // aria-title="show all rows"
          >
            See all{" "}
            <span className="material-symbols-outlined">arrow_forward_ios</span>
          </Link>
        </div>
        <ProductModal
          show={isProductModal}
          onHide={() => setIsProductModal(false)}
        />
      </div>
    </>
  );
}

export default SportsCarousel;
